export default __webpack_public_path__ + "e29c78d9902c3da3fa21e471ca09944a.png";